export const convertGoogPlaceDetailsToMoowLocation=(googPlaceDetails, placeId)=>{
    try{
        let number=''
        let street=''
        let municipality=''
        let county=''
        let country=''

        let googAdrComponents = googPlaceDetails.address_components
        for(let component of googAdrComponents){
          if(component.types.indexOf('street_number') >= 0){
            number = component.short_name
          }
          if(component.types.indexOf('route') >= 0){
            street = component.short_name
          }
          if(component.types.indexOf('locality') >= 0){
            municipality = component.short_name
          }
          if(component.types.indexOf('administrative_area_level_1') >= 0){
            county = component.short_name
          }
          if(component.types.indexOf('country') >= 0){
            country = component.long_name
          }
        }

        return {
           address:{
             country:country,
             county: county,
             municipality: municipality,
             street: street,
             number: number,
             apartNumber: -1,
           },
           placeId: placeId,
           geoCoords:[ googPlaceDetails.geometry.location]
         }
    }catch(err){
        return {
            address:{
                county: '',
                municipality: '',
                street: '',
                number: '',
            },
            location: {lat: 59.0000, lng:24.0000}
        }
    }
}

export const formatAddress_MuniStreetBuilding_Number=(addressObj)=>{
    if(!addressObj) return "Unknown"
    var res = ""
    addressObj.street?res+=addressObj.street+" ": void 0;
    addressObj.number?res+=addressObj.number+" ": void 0;
    addressObj.apartNumber?res+="- "+addressObj.apartNumber: void 0;
    addressObj.municipality?res+=", "+addressObj.municipality: void 0;
    return res
}
  


// WEBPACK FOOTER //
// ./src/utils/address/addressUtil.js